<form *ngIf="!showLoading" class="form" [formGroup]="customerEligibilityWorkplaceFormGroup">

  <div *ngIf="showStateZipSection" id="state-zipcode-section">
    <div class="row no-gutters">
      <div class="col-12 location-question">
        {{cfetLabels.cfet_customer_eligibility.select_workplace_desc_utf}}
      </div>
    </div>
    <div class="row no-gutters" id="row-dropdown">
      <div class="col-12 form-row" id="state-dropdown-section">
        <label for="state-label" id="state-label">{{cfetLabels.cfet_customer_eligibility.state}}</label>
        <div class="field-group" id="state-dropdown">
          <div [ngClass]="checkState ? 'dropdown-opened' : ''">
            <abs-dropdown [drId]="'select_state'" [drName]="'stateValue'" [(dropdownValue)]="stateValueOption"
              formControlName="stateValue" [optionRepeat]="stateList" (dropdownValueChange)="onChangeState($event)"
              (click)="onClickState($event)" ngDefaultControl>
            </abs-dropdown>
          </div>
        </div>
      </div>
      <div class="col-12 form-row mt-3" id="zipcode-input" [class.error]="zipcodeError">
        <label for="zipcode" id="zip-code-label">{{cfetLabels.cfet_customer_eligibility.zipcode}}</label>
        <div [ngClass]="zipcodeError ? 'zipcode-inputbox-error' : 'zipcode-inputbox'">
          <input id="zipcode" class="zipcode" name="zipcode" tabindex="0" formControlName="zipCode" maxlength="5"
            autocomplete="off" type="text" restrict-input="restrictUTFzipcode" (blur)="checkZip()"
            (input)="changeZip()">
          <div *ngIf="zipcodeError" id="zipcode-error" role="alert" [attr.aria-atomic]="true"
            [ngClass]="{'error-msg' : (zipcodeError)}">
            <em class="icon-badgealert" aria-hidden="true"></em>
            <span *ngIf="zipcodeError">{{cfetMessages.valid_zipcode}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 btn-container-state-zip1" *ngIf="!showSearchSection">
        <a tabindex="0" type="button" id="cancel_link" (click)="cancelApplication($event)"
          (keyup)="cancelApplication($event)">
          <em aria-label=""></em>
          {{cfetButtonLabels.button_labels.cancel}}</a>
        <button tabindex="0" type="button" id="back-btn1" (click)="editStateZip($event)" (keyup)="editStateZip($event)">
        {{cfetButtonLabels.button_labels.back}}</button>
        <button tabindex="0" id="continue_link" class="link-style" [class.disabled]="disabledContinueButton"
          (click)="!disabledContinueButton && fetchOrganizationDetails()"
          (keyup)="!disabledContinueButton && fetchOrganizationDetails()" [attr.aria-disabled]="disabledContinueButton">
          {{ cfetButtonLabels.button_labels.continue }}
        </button>
      </div>
    </div>

    <div id="search-organization-section">
      <div id="selected-state-zip-section" *ngIf="showSelectedStateZip">
        <div class="row no-gutters">
          <div class="col-md-10 role-mobile">
            <div class="selected-state-zip-row">
              {{cfetLabels.cfet_customer_eligibility.selected_statezip_utf_desc}}
            </div>
          </div>
        </div>
        <div id="selected-state-zip">{{selectedState}}, {{selectedZip}}</div>
      </div>

      <div class="row no-gutters" *ngIf="showSearchSection">
        <div class="col-md-12 search-workplace" id="search-section">
          <label for="search-box" id="search-box">{{cfetLabels.cfet_customer_eligibility.search_utf}}</label>
          <div id="search-input" class="search-input">
            <input class="nosubmit" type="text" id="searchbox" formControlName="searchValue" tabindex="0"
              autocomplete="off" placeholder="Enter organization name" (keyup)="searchWorkplace()"
              [ngClass]="{'searched':displaySearchResult}">
            <img id="search-icon" *ngIf="!displaySearchResult" src="assets/images/D037_Search_16.png" alt="Search Icon"
              tabindex="0" (click)="searchWorkplace()" (keyup)="searchWorkplace()" style="display:none">
            <img id="search-icon" *ngIf="displaySearchResult" src="assets/images/D038_Search_16.png" alt="Search Icon"
              tabindex="0" (click)="searchWorkplace()" (keyup)="searchWorkplace()" style="display:none">
            <div id="search-result" *ngIf="displaySearchResult || noResultsFound">
              <div id="workplace-link">
                <p id="manually-enter" *ngIf="noResultsFound"><a (click)="addManually($event)"
                    (keyup)="addManually($event)"
                    tabindex="0">{{cfetLabels.cfet_customer_eligibility.cannot_find_workplace}}</a></p>
              </div>
              <ul id="workplace-list" role="menu" *ngIf="displaySearchResult">
                <li id="workplace-details" *ngFor="let row of workplaceList;let i= index;"
                  (click)="onChangeWorkplace($event, row)" (keyup)="onChangeWorkplace($event, row)" tabindex="0">
                  <p id="bold-text">{{row.org_name}}</p><br>
                  <p id="gray-text">{{row.address}}, {{row.city}}, {{row.state.slice(0,2)}} {{row.zipcode}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div id="selected-search-result-section" *ngIf="showSelectedSearchedResult">
            <div class="selected-org-name">
              <h2>{{selectedName}}
                <p id="selected-org-address" *ngIf="selectedStateInWorkplace.length > 0">{{selectedAddress}},
                  {{selectedCity}},
                  {{selectedStateInWorkplace.slice(0,2)}}
                  {{selectedZipInWorkplace}}</p>
              </h2>
            </div>
          </div>

        </div>
      </div>

      <div id="dont-see-your-workplace-section" *ngIf="showDontSeeWorkplaceManually">
        <div id="dont-see-your-workplace-container">
          <app-dont-see-your-workplace-utf-form
            (showSelectedStateZipAndSearchSection)="editWorkplaceOnManualEntry($event)"
            (manualValues)="manualValues($event)" (stateAndZipPresent)="saveManualValues($event)"
            (manualeligibilitycompletionstatus)="manualCompleteStatus($event)"
            (showCancelModal)="displayCancelModal($event)">
          </app-dont-see-your-workplace-utf-form>
        </div>
      </div>
    </div>

    <div id="linkAcoountWithAFfiliationCode" class="linkAcoountWithAFfiliationCode" *ngIf="showAffCodeSection">
      <div id="affCodeFound">
        <p id="affCodeFoundHeading"><em
            class="icon-numslets-linear-info"></em>{{cfetLabels.cfet_customer_eligibility.aff_code_found}}</p>
        <div class="affCodeDescriptions">
          <p id="affCodeFoundDesc1">{{cfetLabels.cfet_customer_eligibility.aff_code_found_desc1}}</p>
          <div class="field-group" id="state-dropdown">
            <div [ngClass]="checkAffCode ? 'dropdown-opened' : ''">
              <abs-dropdown [drId]="'select_affCode'" [drName]="'affiliationCodeValue'"
                [(dropdownValue)]="affiliationCodeValueOption" [optionRepeat]="affiliationCodeList"
                (dropdownValueChange)="onChangeAffCode($event)" (click)="onClickAffiliation($event)" ngDefaultControl>
              </abs-dropdown>
            </div>
          </div>
          <p id="affCodeFoundDesc2">{{cfetLabels.cfet_customer_eligibility.aff_code_found_desc2}}</p>
          <p id="affCodeFoundDesc3" [innerHTML]="cfetLabels.cfet_customer_eligibility.aff_code_found_desc3"></p>
          <p id="affCodeFoundDesc4">{{cfetLabels.cfet_customer_eligibility.aff_code_found_desc4}}</p>
        </div>
        <div class="col-md-12 btn-container">
          <button tabindex="0" type="button" id="no-aff-code-btn" class="btn btn-alt btn-medium"
            (click)="noAffCodeSelected($event)" (keyup)="noAffCodeSelected($event)">
            {{cfetButtonLabels.button_labels.continue_without_affCode}}
          </button>
          <button tabindex="0" type="button" id="yes-aff-code-btn" class="btn btn-alt btn-medium"
            (click)="goToGoodNewsPage($event)" (keyup)="goToGoodNewsPage($event)" [disabled]="disableAffContinue">
            {{cfetButtonLabels.button_labels.continue_with_affCode}}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="(!showDontSeeWorkplaceManually && showSearchSection && !hideButtons)"
      class="col-md-12 btn-container-state-zip">
      <a tabindex="0" type="button" id="cancel_link" (click)="cancelApplication($event)"
        (keyup)="cancelApplication($event)">
        <em aria-label=""></em>
        {{cfetButtonLabels.button_labels.cancel}}</a>
      <button tabindex="0" type="button" id="back-btn" (click)="editStateZip($event)" (keyup)="editStateZip($event)">
        {{cfetButtonLabels.button_labels.back}}</button>
      <button tabindex="0" type="button" id="search_btn-continue" class="btn btn-alt btn-medium"
        (click)="goToGoodNewsPage($event)" (keyup)="goToGoodNewsPage($event)"
        [disabled]="disableSearchPageContinueButton">
        {{cfetButtonLabels.button_labels.continue}}</button>
    </div>
  </div>

  <div class="" id="eligibility-completion-section" *ngIf="showEligibilityCompletion">
    <app-customer-eligibility-utf-completion *ngIf="!showVerifySection" (signupDoneStatus)="signupDone($event)"
      (showCancelModal)="displayCancelModal($event)">
    </app-customer-eligibility-utf-completion>
  </div>


</form>

<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>